(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ej-featured-products-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__fpParallaxLoaded) return;
    window.__fpParallaxLoaded = true;

    var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMQ = window.matchMedia('(max-width: 749px)');

    function init(root) {
      if (root.__fpInit) return;
      root.__fpInit = true;

      var enabled = root.getAttribute('data-parallax') === 'true';
      var mobileOn = root.getAttribute('data-parallax-mobile') === 'true';
      var items = [].slice.call(root.querySelectorAll('[data-fp-speed]'));
      var ticking = false;
      var listening = false;

      function apply() {
        ticking = false;
        if (!root.isConnected) { stop(); return; }
        var off = !enabled || reduceMQ.matches || (mobileMQ.matches && !mobileOn);
        var scrolled = Math.max(0, -root.getBoundingClientRect().top);
        for (var i = 0; i < items.length; i++) {
          var speed = parseFloat(items[i].getAttribute('data-fp-speed')) || 0;
          var y = off ? 0 : -(scrolled * speed / 100);
          items[i].style.setProperty('--py', y.toFixed(1) + 'px');
        }
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(apply); }
      }

      function start() {
        if (listening) return;
        listening = true;
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll);
        apply();
      }

      function stop() {
        if (!listening) return;
        listening = false;
        window.removeEventListener('scroll', onScroll);
        window.removeEventListener('resize', onScroll);
      }

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { start(); } else { stop(); }
          });
        }, { threshold: 0 }).observe(root);
      } else {
        start();
      }

      /* ---------- Add to cart (AJAX) ---------- */
      root.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.matches || !form.matches('form.fp__form')) return;
        if (!window.fetch || !window.FormData) return; /* fall back to normal form submit */

        e.preventDefault();
        var btn = form.querySelector('.fp__atc');
        var label = btn.querySelector('.fp__atc-label');
        if (btn.classList.contains('is-loading')) return;

        var original = btn.getAttribute('data-label') || label.textContent;
        var addUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
        var redirect = root.getAttribute('data-atc-redirect') === 'true';
        var cartUrl = root.getAttribute('data-cart-url') || '/cart';

        btn.classList.add('is-loading');
        label.textContent = btn.getAttribute('data-adding') || 'Adding...';

        var body = new FormData(form);
        body.append('quantity', '1');

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: body
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) { throw new Error(data.description || data.message || 'Error'); }
              return data;
            });
          })
          .then(function () {
            if (redirect) { window.location.href = cartUrl; return; }
            label.textContent = btn.getAttribute('data-added') || 'Added';
            /* Let the theme know the cart changed (cart drawer / bubble can listen to this) */
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            setTimeout(function () {
              label.textContent = original;
              btn.classList.remove('is-loading');
            }, 1800);
          })
          .catch(function (err) {
            label.textContent = (err && err.message && err.message.length < 40) ? err.message : 'Try again';
            setTimeout(function () {
              label.textContent = original;
              btn.classList.remove('is-loading');
            }, 2200);
          });
      });
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-fp]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ej-ingredients-slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__igLoaded) return;
    window.__igLoaded = true;

    var reduceMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
    var mobileMQ = window.matchMedia('(max-width: 749px)');

    function init(root) {
      if (root.__igInit) return;
      root.__igInit = true;

      var viewport = root.querySelector('[data-ig-viewport]');
      var track = root.querySelector('[data-ig-track]');
      if (!viewport || !track) return;

      var originals = [].slice.call(track.children);
      if (!originals.length) return;

      var autoplay = root.getAttribute('data-autoplay') === 'true';
      var dragOn = root.getAttribute('data-drag') === 'true';
      var pauseHover = root.getAttribute('data-pause-hover') === 'true';
      var dir = root.getAttribute('data-dir') === 'right' ? 1 : -1;
      var speedD = parseFloat(root.getAttribute('data-speed-d')) || 0;
      var speedM = parseFloat(root.getAttribute('data-speed-m')) || 0;

      var x = 0;          /* current offset of the track */
      var setW = 0;       /* width of ONE full set of cards (+ gaps) = one loop */
      var vel = 0;        /* swipe momentum */
      var dragging = false;
      var moved = false;
      var hover = false;
      var raf = 0;
      var last = 0;
      var startX = 0, startPos = 0, lastX = 0;
      var resizeTimer = 0;

      /* ---------- Build the circular list ----------
         The original cards are cloned until the track is longer than the screen.
         When the first set has fully scrolled out, the offset jumps back by exactly
         one set width, so the end of the list always connects to the start. */
      function build() {
        [].slice.call(track.querySelectorAll('[data-ig-clone]')).forEach(function (n) { n.remove(); });

        var cs = window.getComputedStyle(track);
        var gap = parseFloat(cs.columnGap) || parseFloat(cs.gap) || 0;

        setW = 0;
        originals.forEach(function (el) { setW += el.getBoundingClientRect().width + gap; });
        if (setW <= 0) return;

        var copies = Math.ceil(viewport.clientWidth / setW) + 1;
        for (var c = 0; c < copies; c++) {
          originals.forEach(function (el) {
            var cl = el.cloneNode(true);
            cl.setAttribute('data-ig-clone', '');
            cl.setAttribute('aria-hidden', 'true');
            cl.removeAttribute('data-shopify-editor-block');
            [].slice.call(cl.querySelectorAll('a')).forEach(function (a) { a.setAttribute('tabindex', '-1'); });
            track.appendChild(cl);
          });
        }
        render();
      }

      function render() {
        if (setW > 0) {
          x = x % setW;
          if (x > 0) x -= setW;
        }
        track.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
      }

      /* ---------- Auto slide + momentum ---------- */
      function tick(now) {
        if (!root.isConnected) { stop(); return; }
        raf = requestAnimationFrame(tick);

        var dt = Math.min(now - last, 50) / 1000;
        last = now;
        if (dragging) return;

        if (Math.abs(vel) > 0.1) {
          x += vel;
          vel *= 0.94;
        } else {
          vel = 0;
          var speed = mobileMQ.matches ? speedM : speedD;
          var paused = pauseHover && hover;
          if (autoplay && speed && !paused && !reduceMQ.matches) {
            x += dir * speed * dt;
          }
        }
        render();
      }

      function start() {
        if (raf) return;
        last = performance.now();
        raf = requestAnimationFrame(tick);
      }

      function stop() {
        if (!raf) return;
        cancelAnimationFrame(raf);
        raf = 0;
      }

      /* ---------- Drag / swipe (mouse, touch, pen) ---------- */
      if (dragOn) {
        viewport.addEventListener('pointerdown', function (e) {
          if (e.pointerType === 'mouse' && e.button !== 0) return;
          dragging = true;
          moved = false;
          vel = 0;
          startX = lastX = e.clientX;
          startPos = x;
        });

        viewport.addEventListener('pointermove', function (e) {
          if (!dragging) return;
          var dx = e.clientX - startX;
          if (!moved && Math.abs(dx) > 5) {
            moved = true;
            viewport.classList.add('is-dragging');
            try { viewport.setPointerCapture(e.pointerId); } catch (err) {}
          }
          if (moved) {
            x = startPos + dx;
            vel = e.clientX - lastX;
            lastX = e.clientX;
            render();
          }
        });

        function endDrag() {
          if (!dragging) return;
          dragging = false;
          viewport.classList.remove('is-dragging');
          if (!moved) vel = 0;
        }
        viewport.addEventListener('pointerup', endDrag);
        viewport.addEventListener('pointercancel', endDrag);
        viewport.addEventListener('lostpointercapture', endDrag);

        /* A drag must not open the card link */
        viewport.addEventListener('click', function (e) {
          if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
        }, true);
        viewport.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }

      viewport.addEventListener('mouseenter', function () { hover = true; });
      viewport.addEventListener('mouseleave', function () { hover = false; });

      /* ---------- Rebuild on resize ---------- */
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          if (root.isConnected) build();
        }, 150);
      });

      build();

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) { start(); } else { stop(); }
          });
        }, { threshold: 0 }).observe(root);
      } else {
        start();
      }
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-ig]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(); });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  /* Scroll to the card the visitor came from (when the URL has a #hash) */
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  /* Add to cart (AJAX). Delegated, so it also works on cards loaded by infinite scroll / filters. */
  (function () {
    if (window.__fpcAtcLoaded) return;
    window.__fpcAtcLoaded = true;

    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.matches || !form.matches('form.fpc__form')) return;
      if (!window.fetch || !window.FormData) return; /* fall back to normal form submit */

      var root = form.closest('[data-fpc]');
      var btn = form.querySelector('.fpc__atc');
      if (!root || !btn) return;

      e.preventDefault();
      var label = btn.querySelector('.fpc__atc-label');
      if (btn.classList.contains('is-loading')) return;

      var original = btn.getAttribute('data-label') || label.textContent;
      var addUrl = (root.getAttribute('data-cart-add-url') || '/cart/add') + '.js';
      var redirect = root.getAttribute('data-atc-redirect') === 'true';
      var cartUrl = root.getAttribute('data-cart-url') || '/cart';

      btn.classList.add('is-loading');
      label.textContent = btn.getAttribute('data-adding') || 'Adding...';

      var body = new FormData(form);
      body.append('quantity', '1');

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: body
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) { throw new Error(data.description || data.message || 'Error'); }
            return data;
          });
        })
        .then(function () {
          if (redirect) { window.location.href = cartUrl; return; }
          label.textContent = btn.getAttribute('data-added') || 'Added';
          /* Let the theme know the cart changed (cart drawer / bubble can listen to this) */
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          setTimeout(function () {
            label.textContent = original;
            btn.classList.remove('is-loading');
          }, 1800);
        })
        .catch(function (err) {
          label.textContent = (err && err.message && err.message.length < 40) ? err.message : 'Try again';
          setTimeout(function () {
            label.textContent = original;
            btn.classList.remove('is-loading');
          }, 2200);
        });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
